export default {
  path: '/team',
  name: 'team',
  meta: { title: '我的团队' },
  children: [
    {
      path: '/team/:type',
      name: 'teamIndex',
      component: () => import('@/views/team/index.vue'),
      meta: { title: '我的团队', subTitle: '专业护航，确保合作效果落地', key: 'team' },
    },
  ],
};
